import { render, staticRenderFns } from "./moduleImgInfo.vue?vue&type=template&id=548c17a5"
import script from "./moduleImgInfo.vue?vue&type=script&lang=js"
export * from "./moduleImgInfo.vue?vue&type=script&lang=js"
import style0 from "./moduleImgInfo.vue?vue&type=style&index=0&id=548c17a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports